<template>
    <div class="privacy-flags">
        <template v-for="p in term.paragraphs">
            <template v-for="t in p.treatments">
                <privacy-flag :flag="t" :key="t.id"/>
            </template>
        </template>
    </div>
</template>

<script>
import PrivacyFlag from './PrivacyFlag'
import {mapState} from 'vuex'

export default {
  name: 'PrivacyFlags',
  components: {
    PrivacyFlag
  },
  computed: {
    ...mapState(['term'])
  }
}
</script>



// WEBPACK FOOTER //
// src/components/PrivacyFlags.vue